// import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};

const CameraLocationsDB = [
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Intro Text',
        ObjectId: null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Floor #1: Royal Derby Hospital',
        ObjectId: null,
        displayMesh: 'Y',
        // cameraLocationLevel2Id: ['', '', '',''],
        // cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Floor #2 Embroiderers Guild ',
        ObjectId: null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Floor #2',
        ObjectId: null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Floor #3: Derby Image Club',
        ObjectId: null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Floor #4',
        ObjectId: null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Floor #5',
        ObjectId: null,
        displayMesh: 'Y',
    },
    {
        cameraLocationId: '',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Floor #5: London Road Panel',
        ObjectId: null,
        displayMesh: 'Y',
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
